// extracted by mini-css-extract-plugin
export var modalFooter = "_tk-0";